<template>
  <div class="task">
    <div v-if="noviceTasks.length">
      <p class="title">新手任务</p>
      <ul class="task">
        <li :key="index" class="flex-ac" v-for="(item, index) in noviceTasks">
          <img :src="require(`@/assets/images/integral/${item.taskImg}`)" alt="" class="logo">
          <div class="right flex-js-ac flex-1">
            <div class="taskContent">
              <p>{{item.taskname}}</p>
              <p class="label over-ell-1">{{item.tasksubtitle}}</p>
              <p class="flex-ac">
                <img class="moneyLogo" src="../../assets/images/integral/money.png" />
                <span class="f12 color-yellow">{{item.integral}}金币</span>
              </p>
            </div>
            <button :class="[item.iscomplete == 2 ? 'greyBg' : item.iscomplete == 1 ? 'redBg' : 'yellowBg', 'btn']" @click="goTask(item)" v-if="item.taskid === 'skintest'">{{item.iscomplete == 2 ? '已完成' : item.iscomplete == 1 ? '领取' : '去测试'}}</button>
            <button :class="[item.iscomplete == 2 ? 'greyBg' : item.iscomplete == 1 ? 'redBg' : 'yellowBg', 'btn']" @click="goTask(item)" v-if="item.taskid === 'bindmobile'">{{item.iscomplete == 2 ? '已完成' : item.iscomplete == 1 ? '领取' : '去绑定'}}</button>
            <button :class="[item.iscomplete == 2 ? 'greyBg' : item.iscomplete == 1 ? 'redBg' : 'yellowBg', 'btn']" @click="goTask(item)" v-if="item.taskid === 'buynewuseritem'">{{item.iscomplete == 2 ? '已完成' : item.iscomplete == 1 ? '领取' : '去看看'}}</button>
            <button :class="[item.iscomplete == 0 ? 'yellowBg' : 'redBg', 'btn']" @click="goTask(item)" v-if="item.taskid == 'wechat'">{{item.iscomplete == 0 ? '去看看' : '领取'}}</button>
            <button class="redBg btn" @click="$router.push('/')" v-if="item.taskid == 'firstbuy' && item.iscomplete == 0">去下单</button>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="everydayTasks.length">
      <p class="title">每日任务</p>
      <ul class="task">
        <li :key="index" class="flex-ac" v-for="(item, index) in everydayTasks">
          <img :src="require(`@/assets/images/integral/${item.taskImg}`)" alt="" class="logo">
          <div class="right flex-js-ac flex-1">
            <div class="taskContent">
              <p>{{item.taskname}}</p>
              <p class="label over-ell-1">{{item.tasksubtitle}}</p>
              <p class="flex-ac">
                <img class="moneyLogo" src="../../assets/images/integral/money.png" />
                <span class="f12 color-yellow">{{item.integral}}金币</span>
              </p>
            </div>
            <div @click="goTask(item)" v-if="item.taskid == 'watchlive'">
              <div class="btn yellowBg" v-if="item.iscomplete == 0" style="position: relative">
                <div class="slide_cl_xcx" path="/pages/personalcenter/pages/livelist/main.html?sorce=10">去看看</div>
              </div>
              <div @click="goTask(item)" class="btn redBg" v-if="item.iscomplete == 1">领取</div>
              <div @click="goTask(item)" class="completed" v-if="item.iscomplete == 2">
                <div>已完成</div>
                <div>明日再来</div>
              </div>
            </div>
            <div v-else>
              <div @click="goTask(item)" class="btn yellowBg" v-if="item.iscomplete == 0">去看看</div>
              <div @click="goTask(item)" class="btn redBg" v-if="item.iscomplete == 1">领取</div>
              <div @click="goTask(item)" class="completed" v-if="item.iscomplete == 2">
                <div>已完成</div>
                <div>明日再来</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="dailyTasks.length">
      <p class="title">日常任务</p>
      <ul class="task">
        <li class="flex-ac" v-for="(item, index) in dailyTasks" :key="index">
          <img class="logo" :src="require(`../../assets/images/integral/${item.taskImg}`)" alt="">
          <div class="right flex-js-ac flex-1">
            <div class="taskContent">
              <p @click="goTask(item)" class="flex-ac">
                <span>{{item.taskname}}</span>
                <van-icon color="#222222" name="arrow" size="14"/>
              </p>
              <p class="label over-ell-1">{{item.tasksubtitle}}</p>
              <p class="flex-ac" v-if="item.taskid !== 'order'">
                <img v-if="item.remark" class="moneyLogo" src="../../assets/images/integral/money.png" />
                <span class="f12 color-yellow" v-html="item.remark"></span>
              </p>
            </div>
            <div :class="[item.earnintegral ? 'color-yellow' : 'color-red', 'btn commonBtn']">
              <div v-if="item.earnintegral == 0">今日<br/>还未获得</div>
              <div v-else>+{{item.earnintegral}}金币</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <van-overlay :show="showshare" v-if="showshare === true" z-index="99">
      <div class="sharecontainer sharefriend">
        <img src="/static/wx/img/sharebg2.png"/>
        <van-button round plain  type="danger" class="know"  @click="showshare = false">我知道了</van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { isWeixin, fenxiang, isApp } from '../../assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'
import Vue from 'vue'
Vue.config.ignoredElements = ['wx-open-launch-weapp']
export default {
  name: 'integralCenter',
  data () {
    return {
      sign: '-1', // 是否已签到
      noviceTasks: [], // 新手任务
      dailyTasks: [], // 日常任务
      everydayTasks: [], // 每日任务
      integral: null,
      integralCouponCount: null,
      integralItemCount: null,
      taskFlag: 0,
      luckFlag: 0,
      noDataText: '——我是有底线的——',
      showshare: false,
    }
  },
  created () {
    let personalInformation = JSON.parse(sessionStorage.getItem('personal_information'))
    this.integral = personalInformation ? personalInformation.integral : null

    this.getTaskInfo()
  },
  mounted () {
  },
  methods: {
    // 获取金币任务
    getTaskInfo () {
      var that = this, url = 'Wxmall/Goldmall/getGoldTask';
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          if (isWeixin()) {
            fenxiang({
              title: encodeURIComponent(res.data.sharetitle ? res.data.sharetitle : ''),
              desc: encodeURIComponent(res.data.sharedesc ? res.data.sharedesc : ''),
              imgx: res.data.shareimg,
              dataStr: 'type=integralindex',
              type: 'integralindex',
              path: 'integralTask'
            })
          }
          that.noviceTasks = that.handleData(res.data.novice_tasks)
          that.dailyTasks = that.handleData(res.data.daily_tasks)
          that.everydayTasks = that.handleData(res.data.everyday_tasks)

          setTimeout(function () {
            that.goXcxCreateBtnFn()
          }, 500)
        }
      })
    },
    handleData(list) {
      for (let i in list) {
        list[i].taskImg = list[i].taskid + '.png'
        if (list[i].remark && typeof list[i].remark != 'string' && list[i].remark.length) {
          list[i].remark = list[i].remark.join('<br/>')
        }
      }
      return list
    },
    // 任务
    goTask (item) {
      if (item.taskid == 'wechat') {
        if (item.iscomplete == 0) { // 未关注
          this.$dialog.alert({
            title: '关注公众号',
            message: '1.微信搜索公众号“创客村”，点击关注。\n' +
            '2.七天不取消即可领取金币。\n' +
            '3.已经关注公众号的七天后领取奖励。',
            className: 'percen_button_alert integral_button_alert PopupIntegral',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '我知道了',
            closeOnPopstate: false,
            messageAlign: 'left'
          }).then(() => {}).catch(() => {})
        } else if (item.iscomplete == 1) { // 已关注未到7天
          this.$dialog.alert({
            message: '关注公众号不足7天',
            className: 'percen_button_alert integral_button_alert PopupIntegral PopupSmall', // 类名
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '确定',
            closeOnPopstate: true, // 页面回退时自动关闭
            showCancelButton: true,
            cancelButtonText: '取消'
          }).then(function () {}).catch(() => {})
        } else if (item.iscomplete == 2) { // 已关注大于7天
          this.getSignIntegral(item)
        }
      } else if (item.taskid === 'skintest') { // 皮肤测试
        if (item.iscomplete === 0) {
          this.$router.push({
            path: '/skinAnalysis'
          })
        } else if (item.iscomplete === 1) {
          this.gollectGoldCoins(item)
        } else {
          this.$toast('当前任务已完成')
        }
      } else if (item.taskid === 'buynewuseritem') { // 新人购买专享商品
        if (item.iscomplete === 0) {
          window.location.href = item.link
        } else if (item.iscomplete === 1) {
          this.gollectGoldCoins(item)
        } else {
          this.$toast('当前任务已完成')
        }
      } else if (item.taskid === 'bindmobile') { // 绑定手机号
        if (item.iscomplete == 0) {
          this.$router.push("/bound");
        } else if (item.iscomplete == 1) {
          this.getBindMobileTaskIntegral()
        }
      } else if (item.taskid === 'watchlive') { // 看直播
        if (item.iscomplete == 0) {
          if (!isWeixin()) {
            this.$toast('请前往微信搜索小程序「创客云商可丽金官方」')
          }
        } else if (item.iscomplete == 1) {
          this.getwatchLiveTaskIntegral()
        } else {
          this.$toast('已完成明日再来')
        }
      } else if (item.taskid === 'browseitemdetail') { // 浏览5个商品详情
        if (item.iscomplete === 0) {
          this.$router.push('/')
        } else if (item.iscomplete === 1) {
          this.gollectGoldCoins(item)
        } else {
          this.$toast('已完成明日再来')
        }
      } else if (item.taskid === 'browsehotactivity') { // 浏览热门活动
        if (item.iscomplete === 0) {
          this.$router.push('/selectact')
        } else if (item.iscomplete === 1) {
          this.gollectGoldCoins(item)
        } else {
          this.$toast('已完成明日再来')
        }
      } else if (item.taskid === 'browsemustbuy') { // 浏览必买榜单
        if (item.iscomplete === 0) {
          window.location.href = item.link.indexOf('?') >= 0 ? (item.link + '&taskid=browsemustbuy') : (item.link + '?taskid=browsemustbuy')
        } else if (item.iscomplete === 1) {
          this.gollectGoldCoins(item)
        } else {
          this.$toast('已完成明日再来')
        }
      } else if (item.taskid === 'order') { // 购物
        this.$router.push("/");
      }else if (item.taskid === 'comment') { // 评论
        this.$router.push("/myorder");
        this.$store.commit("ORDERLIST_NAVID", 3);
      } else if (item.taskid === 'share_item' || item.taskid === 'share_order') { // 分享商品 && 分享后下单
        this.$router.push("/");
      } else if (item.taskid === 'thumbsup') { // 点赞
        this.$router.push('/classification')
      } else if (item.taskid === 'invitationuser') {
        var arg = isApp()
        if (arg == '' || arg.indexOf('xcx') >= 0) {
          if (isWeixin()) {
            this.showshare = true
          } else {
            this.$toast('关注【创客村】公众号，惊喜享不停')
          }
        }
      } else if (item.taskid === 'community_posts') {
        this.$store.commit('COMMUNITY_TAB', 1)
        this.$router.push({
          path: '/community'
        })
      }
    },
    // 获取积分
    gollectGoldCoins(item) {
      let that = this, url;
      if (item.taskid === 'skintest') {
        url = 'Wxmall/Goldmall/addSkintestGold'
      } else if (item.taskid === 'buynewuseritem') {
        url = 'Wxmall/Goldmall/addItemGold'
      } else if (item.taskid === 'browseitemdetail') {
        url = 'Wxmall/Goldmall/addBrowseGold'
      } else {
        url = 'Wxmall/Goldmall/addHotActivityGold'
      }
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          that.$toast({
            message: '金币已领取'
          })
          that.getTaskInfo()
        } else {
          that.$toast({
            message: res.data.msg
          })
        }
      })
    },
    // 观看直播领金币
    getwatchLiveTaskIntegral () {
      var that = this, url = 'Wxmall/Integralmall/addLiveIntegral';
      customRequestAjax.post(url).then(res => {
        if (res.data.code === 200) {
          that.$toast({
            message: '金币已领取'
          })
          that.getTaskInfo()
        } else {
          that.$toast({
            message: '金币领取失败，请稍后重试'
          })
        }
      })
    },
    // 领取绑定手机号金币
    getBindMobileTaskIntegral () {
      var that = this, url = 'Wxmall/Integralmall/getBindMobileTaskIntegral';
      customRequestAjax.post(url).then(res => {
        if (res.data.code === 200) {
          that.$toast({
            message: '金币已领取'
          })
          that.getTaskInfo()
        } else {
          that.$toast({
            message: '金币领取失败，请稍后重试'
          })
        }
      })
    },
    goXcxCreateBtnFn: function () {
      this.$nextTick(function () {
        var slideClXcx = document.getElementsByClassName('slide_cl_xcx')
        for (var i = 0; i < slideClXcx.length; i++) {
          if (slideClXcx[i].attributes.path.value) {
            var script = document.createElement('script')
            script.type = 'text/wxtag-template'
            script.text = `<div style="width: ${slideClXcx[i].clientWidth}px; height: ${slideClXcx[i].clientHeight}px; line-height: ${slideClXcx[i].clientHeight}px; font-size: 12px; text-align:center;color:#fff" class="box">去看看</div>`
            slideClXcx[i].innerHTML = `<wx-open-launch-weapp
              style="display:block; width:100%;height:100%;"
              id="launch-btn"
              username="gh_5d4bb8e18b8b"
              path="${slideClXcx[i].attributes.path.value}"
              @error="handleErrorFn"
              @launch="handleLaunchFn"
            >去看看${script.outerHTML}</wx-open-launch-weapp>`
          }
        }
      })
    },
    // 领取金币-关注公众号
    getSignIntegral () {
      var that = this, url = 'Wxmall/Integralmall/getWechatDetailList';
      customRequestAjax.post(url).then(res => {
        if (res.data.code === 200) {
          that.$toast({
            message: '已领取'
          })
          that.getTaskInfo()
        }
      })
    },
    // 领取金币-完善个人信息
    changeStatus () {
      var that = this, url = 'Wxmall/Integralmall/getUserDetailList';
      customRequestAjax.post(url).then(res => {
        if (res.data.code === 200) {
          that.$toast({
            message: '金币已领取'
          })
          that.getTaskInfo()
        }
      })
    },
  }
}

</script>
<style lang="scss">
  .percen_button_alert .van-dialog__footer .van-button--large {
    padding: 0 !important;
  }
</style>
<style lang="scss" scoped>
@import '../../assets/common/css/integral.scss';
.bottomLine {
  color: #A8A8A8;
  font-size: 0.12rem;
  line-height: 0.42rem;
  text-align: center;
}
.task {
  .color-yellow {
    color: #FFB346 !important;
  }
  .yellowBg {
    background: #FFB346;
  }
  .completed {
    font-size: 0.12rem;
    color: #C7C7C7;
    text-align: center;
  }
  .color-red {
    color: #FC0324 !important;
  }
  .redBg {
    background: #FC0324;
  }
  .greyBg {
    background: #C7C7C7;
  }
  .title {
    font-size: 0.18rem;
    color: #222;
    line-height: 0.18rem;
    margin: 0.15rem 0.11rem 0.1rem;
    img {
      width: 0.16rem;
      height: 0.16rem;
      margin-left: 0.04rem;
    }
  }
  .task {
    background: #fff;
    margin: 0 0.11rem;
    border-radius: 0.04rem;
    >p {
      font-size:0.18rem;
      font-weight:400;
      color:rgba(34,34,34,1);
      line-height:0.25rem;
      padding: 0.1rem 0.11rem 0.07rem;
    }
    li {
      position: relative;
      min-height: 0.8rem;
      box-sizing: border-box;
      padding: 0 0.1rem;
      .grey{
        background: #ddd;
        color: #fff;
      }
      &:last-of-type {
        border-bottom: none;
      }
      .logo {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.1rem;
      }
      .right {
        padding: 0.1rem 0;
        border-bottom: 0.01rem solid #eee;
      }
      .taskContent {
        width: 2rem;
        font-size: 0;
        .moneyLogo {
          margin-right: 0.04rem;
          width: 0.16rem;
          height: 0.16rem;
        }
        p {
          font-size:0.14rem;
          font-weight:400;
          color: #222;
          line-height:0.2rem;
        }
        .label {
          margin: 0.02rem 0;
          font-size:0.12rem;
          font-weight:400;
          color:rgba(156,156,156,1);
          line-height:0.17rem;
        }
      }
      .btn {
        min-width:0.7rem;
        border-radius:0.14rem;
        border: none;
        outline: none;
        font-size:0.12rem;
        height: 0.26rem;
        line-height: 0.26rem;
        box-sizing: border-box;
        text-align: center;
        color: #fff;
        &.commonBtn {
          line-height: 0.17rem;
          min-width: 0.4rem;
        }
        &.redBtn {
          background:rgba(252,3,36,1);
          color:#FFFCFC;
        }
        &.grayBtn {
          background:#DDDDDD;
          color:#FFFCFC;
        }
        &.redBorderBtn{
          background: #fff;
          border: 0.01rem solid #FC0324;
          color: #FC0324;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/integral/integralTask.vue